import DOMPurify from 'dompurify';

// 節目的 summary / description 來自 radiko，含 <br>、<a> 等 HTML 標籤，需以
// dangerouslySetInnerHTML 渲染。統一經 DOMPurify 消毒後再輸出，避免 XSS。
// 用法：<span dangerouslySetInnerHTML={sanitizedHtml(program.summary)} />
export function sanitizedHtml(html) {
  return { __html: DOMPurify.sanitize(html || '') };
}
